const PortfolioCard = ({ data }) => {
  return (
    <section className='DBlock portfolioCard'>
      <div className='relative h-full'>
        <img
          className='object-cover w-full menuImg'
          src={data?.img}
          alt='submenuImg'
        />
        <div className='overlay'></div>
        {data && (
          <div className='text-right absolute bottom-6 left-0'>
            <p className='text-white text-base uppercase tracking-wider font-medium'>
              AUGUST 19-2019
            </p>
            <h3 className='md:text-4xl text-2xl text-white font-bold capitalize ml-4'>
              {data.title}
            </h3>
            <div className='heading my-1'></div>
            <p className='text-white text-base capitalize tracking-wider font-medium'>
              <span className='font-semibold'>By:</span> De evente events
            </p>
          </div>
        )}
      </div>
    </section>
  );
};

export default PortfolioCard;
